<template>
  <bar-chart :chartdata="chartdata" :styles="styles" :options="options" />
</template>

<script>
import BarChart from '@/components/charts/bar'

export default {
  name: 'PhoneNumberBar',
  components: {
    BarChart
  },
  props: {
    numbers: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      chartdata: null,
      styles: {
        height: '32vh',
        width: '100%',
        position: 'relative'
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            stacked: true
          }],
          yAxes: [{
            stacked: true,
            ticks: {
              stepSize: 1
            }
          }]
        }
      }
    }
  },
  methods: {
    fillchartdata: function () {
      var labels = []
      var data = []
      var colours = []
      for (var i = 0; i < this.numbers.length; i++) {
        labels.push(this.numbers[i].key)
        data.push(this.numbers[i].value)
        colours.push(this.randomColorGenerator())
      }
      this.chartdata = {
        labels: labels,
        datasets: [{
          label: 'numbers',
          backgroundColor: colours,
          data: data
        }]
      }
    },
    randomColorGenerator: function () {
      return '#' + (Math.random().toString(16) + '0000000').slice(2, 8)
    }
  },
  created: function () {
    this.fillchartdata()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/charts/PhoneNumbersBar.vue